import { gql } from '@apollo/client'

export default gql`
  mutation M($chatMessageIds: [String]!) {
    markChatMessagesReceived(chatMessageIds: $chatMessageIds)
  }
`
